import { Relation } from "../enums/Relation";
import { ApplicationStatus } from "../enums/ApplicationStatus";
import { BaseEntity } from "./BaseEntity";
import { UserRepresentation, UserRepresentationFromJSON, UserRepresentationToJSON } from "./UserRepresentation";
import moment from "moment";
import { RepresentationRequestType } from "../enums/RepresentationRequestType";

export interface BatchApplication extends BaseEntity {
    requestorUser?: UserRepresentation;
    requesteeUsername?: string;
    requesteeCustomerNumber?: string;
    relation?: Relation;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ApplicationStatus;
    acknowledgedDate?: Date | undefined;
    errorCode?: string;
    representationRequestType?: RepresentationRequestType;
    updateRequired?: boolean;
}

export function BatchApplicationFromJSON(json: any): BatchApplication {
    if((json === undefined) || (json === null)) {
        return json;
    }

    return {
        'id': json['id'],
        'created': json['created'] ? new Date(json['created']) : undefined,
        'requestorUser': UserRepresentationFromJSON(json['requestorUser']),
        'requesteeUsername': json['requesteeUsername'],
        'requesteeCustomerNumber': json['requesteeCustomerNumber'],
        'relation': json['relation'],
        'startDate': json['startDate'] ? new Date(json['startDate']) : undefined,
        'endDate': json['endDate'] ? new Date(json['endDate']) : undefined,
        'status': json['status'],
        'acknowledgedDate': json['acknowledgedDate'] ? new Date(json['acknowledgedDate']) : undefined,
        'errorCode': json['errorCode'],
        'representationRequestType': json['representationRequestType']
    }
}

export function BatchApplicationToJSON(value?: BatchApplication | null): any {
    if(value === undefined) {
        return undefined;
    }
    if(value === null) {
        return null;
    }
    return {
        'id': value.id,
        'created': value.created ? moment(value.created).format('yyyy-MM-DDTHH:mm:ssZZ') : '',
        'requestorUser': UserRepresentationToJSON(value.requestorUser),
        'requesteeUsername': value.requesteeUsername,
        'requesteeCustomerNumber': value.requesteeCustomerNumber,
        'relation': value.relation,
        'startDate': value.startDate ? moment(value.startDate).format('yyyy-MM-DDTHH:mm:ssZZ') : '',
        'endDate': value.endDate ? moment(value.endDate).format('yyyy-MM-DDTHH:mm:ssZZ') : '',
        'status': value.status,
        'acknowledgedDate': value.acknowledgedDate ? moment(value.acknowledgedDate).format('yyyy-MM-DDTHH:mm:ssZZ') : '',
        'errorCode': value.errorCode,
        'representationRequestType': value.representationRequestType
    }
}